import { Component, Input, OnInit } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

import { Subject } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';
import { SecurityIndexService } from 'src/app/core/data-services/company/securityIndex.service';
import { CompanySecurity } from 'src/app/shared/models/company/company-security.model';
import { SecurityIndex } from 'src/app/shared/models/company/security-index.model';

@Component({
  selector: 'rms-security-index-search',
  templateUrl: './security-index-search.component.html',
  styleUrl: './security-index-search.component.scss',
  standalone: false,
})
export class SecurityIndexSearchComponent implements OnInit {

  @Input() itemDescription = "";
  @Input() securitySelected: (securityIndex: SecurityIndex) => void;
  @Input() createManually: (select: NgSelectComponent) => void;
  @Input() existingSecurities: Array<CompanySecurity>;

  public securityIndexTypeahead = new Subject<string>();
  public securityIndexSearching = false;
  public securityIndexList: Array<SecurityIndex & {disabled: boolean}> = [];

    constructor (
      private securityIndexService: SecurityIndexService,
      ) { }


  ngOnInit(): void {
    this.initAutocomplete();
  }

  private initAutocomplete() {
      this.securityIndexTypeahead.pipe(
        distinctUntilChanged(),
        debounceTime(200),
        switchMap(term => {
          this.securityIndexSearching = true;
          return this.securityIndexService.autocompleteSecurityCompanies({ q: term });
        }),
      ).subscribe(records => {
        const existingFsymIds = this.existingSecurities?.map(es => es.fsymId).filter(Boolean);
        const okFactsetEntityIds = [...new Set(records?.filter(r =>
          existingFsymIds?.includes(r.fsymId)).map(r => r.factsetEntityId))];
        this.securityIndexSearching = false;
        this.securityIndexList = (records || []).map((r) =>
          ({
            ...r,
            disabled: !!r.companyId ||
              (existingFsymIds?.length > 0 && !okFactsetEntityIds.includes(r.factsetEntityId))
          }))
          .filter(r => r.currency && r.tickerRegion && r.fsymRegionalId && r.listingExchange)
          .sort((a,b) => {
            const nameCompare = a.properName.localeCompare(b.properName);
            return nameCompare === 0 ?
              a.exchangeDescription.localeCompare(b.exchangeDescription) :
              nameCompare;
          });
      }, () => {
        this.securityIndexSearching = false;
        this.securityIndexList = [];
      });
    }

}
